import { render } from "./NuevoContactoRegistro.vue?vue&type=template&id=cfb8934a"
import script from "./NuevoContactoRegistro.vue?vue&type=script&lang=js"
export * from "./NuevoContactoRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__